import { render, staticRenderFns } from "./pendingForm.vue?vue&type=template&id=39cacebe&scoped=true&"
import script from "./pendingForm.vue?vue&type=script&lang=tsx&"
export * from "./pendingForm.vue?vue&type=script&lang=tsx&"
import style0 from "./pendingForm.vue?vue&type=style&index=0&id=39cacebe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cacebe",
  null
  
)

export default component.exports